import React, { useEffect, useState } from "react";
import apiMaestras from "../../../../../api/Maestras/api-maestras";
import { Convocatoria } from "../../../../../models/ConvocatoriasModel/convocatoria.model";
import "./Banner.scss";
import moment from "moment";
import { CalendarOutlined } from "@ant-design/icons";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import ImageNotFound from "../../../../../assets/enmascarar-detail.png";

interface IProps {
  convocatorias: Convocatoria;
}

export const Banner: React.FC<IProps> = (props: IProps) => {
  const [dataImg, setDataImg] = useState<any>();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }
  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  const getStatusConvocatoria = (convocatorias: any) => {

    let fechaactual = moment()
    if (convocatorias.fechas.length > 0) {
      for (var y in convocatorias.fechas) {
        let fechavalida =
          moment(convocatorias.fechas[y].valormax).isValid() ?
            moment(convocatorias.fechas[y].valormax) :
            moment(convocatorias.fechas[y].valormin);
        if (
          convocatorias.fechas[y].clave === "Apertura" &&
          moment(fechaactual).isBefore(moment(convocatorias.fechas[y].valormin))
        ) {
          convocatorias.estado = "En espera";
        }
        if (
          convocatorias.fechas[y].clave === "Apertura" &&
          moment(fechaactual).isSameOrAfter(moment(convocatorias.fechas[y].valormin))
        ) {
          convocatorias.estado = "Abierta";
        }
        if (
          convocatorias.fechas[y].clave === "Cierre" &&
          moment(fechaactual).isSameOrAfter(fechavalida)
        ) {
          convocatorias.estado = "Cerrada";
        }
        if (
          convocatorias.fechas[y].clave ===
          "Resolución de otorgamiento" &&
          moment(fechaactual).isSameOrAfter(fechavalida)
        ) {
          convocatorias.estado = "Cerrada";
        }
        if (!convocatorias.publico) {
          convocatorias.estado = "No publicada";
        }
      }
    }
  }

  useEffect(() => {
    getLineasConvocatorias();
  }, [])

  useEffect(() => {
    getStatusConvocatoria(props.convocatorias);
    getImageConvocatoria();
  }, [props.convocatorias]);

  getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)

  return (
    <div className="container-background-participantes" style={{ backgroundImage: dataImg ? `url(${dataImg})` : `url(${ImageNotFound})`, height: '500px', backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
      <div className="subcontainer-background-participantes">
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 col-md-9 mt-5 mb-5 px-5">
              <div className="row" style={{ width: '800px' }}>
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-16px font-color-FFFFFF texto-sombras-general"
                >
                  Fechas de la convocatoria
                </div>

                <div className="d-flex align-items-center justify-content-center">
                  <div className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general" style={{ marginTop: '20px' }}>
                    <p>
                      <CalendarOutlined style={{ fontSize: '40px' }} />
                    </p>
                  </div>

                  <div
                    className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general"
                  >
                    <span className="no-margin subtexto-sombras-general container-detalle-card-body-bold" style={{ fontSize: '14px' }}>
                      Inicia:
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: '14px' }}>
                      {props.convocatorias.fechas !== null &&
                        props.convocatorias.fechas.length > 0
                        ? props.convocatorias.fechas.filter(
                          (data) => data.clave === "Apertura"
                        ).length > 0
                          ? `${moment(
                            props.convocatorias.fechas
                              .filter((data) => data.clave === "Apertura")[0]
                              .valormin.substring(0, 10)
                          ).format("ll")} ${moment(props.convocatorias.fechas
                            .filter((data) => data.clave === "Apertura")[0].valormax).isValid() && moment(props.convocatorias.fechas.filter((data) => data.clave === "Apertura")[0].valormax).format("ll") !== moment(props.convocatorias.fechas.filter((data) => data.clave === "Apertura")[0].valormin).format("ll") ? `al ${moment(props.convocatorias.fechas.filter((data) => data.clave === "Apertura")[0].valormax.substring(0, 10)).format("ll")}` : ""}`
                          : null
                        : null}
                    </div>
                  </div>

                  <div className="col-6  font-family-Montserrat-Regular font-size-10px font-color-FFFFFF subtexto-sombras-general">
                    <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '14px' }}>
                      Finaliza:
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: '14px' }}>
                      {props.convocatorias.fechas !== null &&
                        props.convocatorias.fechas.length > 0
                        ? props.convocatorias.fechas.filter(
                          (data) => data.clave === "Cierre"
                        ).length > 0
                          ? `${moment(
                            props.convocatorias.fechas
                              .filter((data) => data.clave === "Cierre")[0]
                              .valormin.substring(0, 10)
                          ).format("ll")} ${moment(props.convocatorias.fechas
                            .filter((data) => data.clave === "Cierre")[0].valormax).isValid() && moment(props.convocatorias.fechas.filter((data) => data.clave === "Cierre")[0].valormax).format("ll") !== moment(props.convocatorias.fechas.filter((data) => data.clave === "Cierre")[0].valormin).format("ll") ? `al ${moment(props.convocatorias.fechas.filter((data) => data.clave === "Cierre")[0].valormax.substring(0, 10)).format("ll")}` : ""}`
                          : null
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
